// extracted by mini-css-extract-plugin
export default {"button":"styles_button__hT7nE","spinner":"styles_spinner__Lwjik"};